import React, { useState } from 'react'
/*var myprop;
var mySetStyle;
var myDarkStyle;
var myLightStyle;
var myTextStyle;
var mySetBtnStyle;
export const aboutToggleHandler = function(){
    if(myprop.mode === "dark")
    {
        mySetStyle(myDarkStyle)
        myTextStyle("Enable light mode")
        mySetBtnStyle("btn-dark")
    }else{
        mySetStyle(myLightStyle)
        myTextStyle("Enable dark mode")
        mySetBtnStyle("btn-primary")
    }
}*/
export default function About(props) {
    //myprop = props;
    const darkStyle = {
        backgroundColor: "black",
        color: "white"
    }
    const lightStyle = {
        backgroundColor: "white",
        color: "black"
    }
//myDarkStyle = darkStyle;
//myLightStyle = lightStyle;
//const [style, setStyle] = useState(lightStyle);
//mySetStyle = setStyle;
//const [text, setText] = useState("Enable dark mode")
//myTextStyle = setText;
//const [btnClass, setBtnClass] = useState("btn-primary")
//mySetBtnStyle = setBtnClass;
  return (
    <>
<div className='container my-3'>
    <h1 style={props.mode==="dark" ? darkStyle : lightStyle}>About us </h1>
    <div className="accordion p-3" id="accordionExample" style={props.mode==="dark" ? darkStyle : lightStyle}>
        <div className="accordion-item">
            <h2 className="accordion-header">
            <button style={props.mode==="dark" ? darkStyle : lightStyle} className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                Accordion Item #1
            </button>
            </h2>
            <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
            <div style={props.mode==="dark" ? darkStyle : lightStyle} className="accordion-body">
                <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
            </div>
            </div>
        </div>
        <div className="accordion-item">
            <h2 className="accordion-header">
            <button style={props.mode==="dark" ? darkStyle : lightStyle} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Accordion Item #2
            </button>
            </h2>
            <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div style={props.mode==="dark" ? darkStyle : lightStyle} className="accordion-body">
                <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
            </div>
            </div>
        </div>
        <div className="accordion-item">
            <h2 className="accordion-header">
            <button style={props.mode==="dark" ? darkStyle : lightStyle} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                Accordion Item #3
            </button>
            </h2>
            <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div style={props.mode==="dark" ? darkStyle : lightStyle} className="accordion-body">
                <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
            </div>
            </div>
        </div>
    </div>
</div>
<div className='container'>
    <button className={(props.mode==="dark") ? "btn btn-dark" : "btn btn-primary"}>{(props.mode==="dark") ? "enable light" : "enable dark"}</button>
</div>
</>
  )
}
